import { createFileRoute } from '@tanstack/react-router';
import { CertificateList } from '@/components/features/supplier-certificates/components/certificate-list';

export const Route = createFileRoute('/_authenticated/supplier-certificates')({
  component: SupplierCertificatesPage,
});

function SupplierCertificatesPage() {
  return (
    <div className="container py-6 space-y-6">
      <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Supplier Certificates</h1>
          <p className="text-muted-foreground mt-1">
            Manage supplier competency certificates and track expiry dates
          </p>
        </div>
      </div>

      <CertificateList />
    </div>
  );
}
